import { Component, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { Attachment, AttachmentControllerService } from '../../../core/generated';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-dialog-upload',
    standalone: true,
    imports: [
        NgxFileDropModule, 
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatProgressBarModule
    ],
    templateUrl: './dialog-upload.component.html',
    styleUrl: './dialog-upload.component.scss'
})
export class DialogUploadComponent {
  data = inject(MAT_DIALOG_DATA);
  expirationDateselected: any;
  documentName: string = '';
  checked: boolean = false;
  droppedFile: any;


  isWaiting = false;

  constructor(
    public dialogRef: MatDialogRef<DialogUploadComponent>,
    private attachmentsService: AttachmentControllerService
  ) {}

  addAttachment(files: NgxFileDropEntry[]) {
    this.droppedFile = files[0];
  }

  upload() {
    if (!this.data.documentType) {
      // Validate document name if customized
      if (!this.documentName || this.documentName.length < 3) return;
      this.data.documentType = this.documentName;
    }

    if (this.droppedFile?.fileEntry?.isFile && this.data.ownerDocumentsCpfCnpj) {
      // Prepare expiration date string if exists
      let expDateStr: string | undefined = undefined;
      if (this.expirationDateselected) {
        // Assuming it's a Date object or something with toISOString, or use Moment if configured
        try {
            expDateStr = new Date(this.expirationDateselected).toISOString();
        } catch (e) {
            console.error('Date conversion error', e);
        }
      }

      const attachment: Attachment = {
        ownerDocumentsCpfCnpj: this.data.ownerDocumentsCpfCnpj,
        documentType: this.data.documentType,
        sharePermitted: true,
        fileName: this.droppedFile.fileEntry.name || 'unknown.file',
        expirationDate: expDateStr
      };

      this.isWaiting = true;
      const fileEntry = this.droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('attachment', JSON.stringify(attachment));

        this.attachmentsService.uploadFile1(file, attachment).subscribe({
          next: (res: Array<Attachment>) => {
            this.dialogRef.close(res);
            this.isWaiting = false;
          }
        });
      });
    }
  }

}
